// extracted by mini-css-extract-plugin
export default {"block":"Block_block__RF-Fk","fixed-min-height":"Block_fixed-min-height__A0hje"};